import { Component } from '@angular/core';

@Component({
  selector: 'app-aul-038-24',
  standalone: true,
  imports: [],
  templateUrl: './aul-038-24.component.html',
  styleUrl: './aul-038-24.component.scss'
})
export class Aul03824Component {

}
